import Chart from "chart.js/auto"
import Chartkick from "chartkick"

// Configure Chartkick to use Chart.js
Chartkick.use(Chart)
  
// NOTE: jQuery UI draggable functionality commented out - was using 566KB jquery-ui library
// TODO: Replace with native HTML5 drag & drop or lightweight library if needed
/*
$(document).on('turbo:load', function() {
    function coordinates(element) {
        element = $(element);
        var top = element.position().top;
        var left = element.position().left;
        $('.top-coord').val(top)
        $('.left-coord').val(left)
    }

    $('.draggable').draggable({
        start: function() {
            coordinates(this);
        },
        stop: function() {
            coordinates(this);
        }
    });
});
*/



